import React, { useState, useEffect } from "react";
import MenuBar from "@/components/MenuBar";
import InterviewFeed from "@/components/InterviewFeed";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const Proto3Page = () => {
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [code, setCode] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    const unlocked = sessionStorage.getItem("proto3_unlocked");
    if (unlocked === "true") {
      setIsUnlocked(true);
    }
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (code === "3333") {
      setIsUnlocked(true);
      sessionStorage.setItem("proto3_unlocked", "true");
      setError(false);
    } else {
      setError(true);
    }
  };

  if (!isUnlocked) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="w-full max-w-sm p-8 bg-card rounded-lg shadow-lg">
          <h2 className="text-2xl font-semibold mb-6 text-center">Skriv inn kode</h2>
          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              type="password"
              inputMode="numeric"
              maxLength={4}
              placeholder="4-sifret kode"
              value={code}
              onChange={(e) => {
                setCode(e.target.value);
                setError(false);
              }}
              className={error ? "border-red-500" : ""}
            />
            {error && (
              <p className="text-sm text-red-500">Feil kode</p>
            )}
            <Button type="submit" className="w-full">
              Lås opp
            </Button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <MenuBar />
      <div className="max-w-4xl mx-auto px-4 pt-2 md:pt-4 pb-6">
        <InterviewFeed forceRefresh={true} />
      </div>
    </div>
  );
};

export default Proto3Page;
